// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2aZwg","content":"style_content__ka8Gy","header":"style_header__3OqLP","text":"style_text__7JqRp"};